import type { KPIResult } from '../api/types'
import { deltaTone, formatChange, formatMetric, metricLabel } from '../format'

interface Props {
  kpi: KPIResult
  comparisonLabel: string
  hero?: boolean
}

const ARROW = { up: '↑', down: '↓', flat: '→' } as const

/**
 * Stat tile: label · value · delta.
 *
 * The delta pairs an arrow glyph with its color so direction survives for readers
 * who cannot distinguish the good/critical hues, and the value uses proportional
 * figures — tabular digits look loose at display sizes.
 */
export function StatTile({ kpi, comparisonLabel, hero = false }: Props) {
  const tone = deltaTone(kpi.change_percent, kpi.name)

  return (
    <div className={`tile${hero ? ' tile--hero' : ''}`}>
      <span className="tile__label">{metricLabel(kpi.name)}</span>
      <span
        className="tile__value"
        title={formatMetric(kpi.name, kpi.current, 'full')}
      >
        {formatMetric(kpi.name, kpi.current)}
      </span>
      <span className={`tile__delta tile__delta--${tone}`}>
        <span aria-hidden="true">{ARROW[tone]}</span>
        {formatChange(kpi.change_percent)}
        <span className="tile__delta-note">vs {comparisonLabel}</span>
      </span>
    </div>
  )
}
